import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Nov 22 2018
 * @author LZe
 */
import * as React from 'react';
import * as ReactDOM from 'react-dom';

var BackButtonPortal =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(BackButtonPortal, _React$PureComponent);

  function BackButtonPortal() {
    var _this;

    _classCallCheck(this, BackButtonPortal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BackButtonPortal).apply(this, arguments));
    _this.state = {
      rootNode: undefined
    };
    return _this;
  }

  _createClass(BackButtonPortal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        rootNode: document.getElementById('back-button')
      }); // Re-render when this.rootNode is ready
    }
  }, {
    key: "render",
    value: function render() {
      return this.state.rootNode !== undefined ? ReactDOM.createPortal(this.props.children, this.state.rootNode) : null;
    }
  }]);

  return BackButtonPortal;
}(React.PureComponent);

export { BackButtonPortal as default };